import { Circle, G, Path, Rect, Svg } from "react-native-svg";

import { useTheme } from "~/styles/theme";

/**
 * The MintStint logomark. Generated from the same geometry as the app
 * icon and the website favicon, so the three surfaces cannot drift apart.
 * Colours are the brand's own — a mark should not follow semantic tokens.
 */
const schemes = {
  light: { plate: "#ffffff", ink: "#002c15", accent: "#3ecf8e" },
  dark: { plate: "#00170b", ink: "#d8f3e5", accent: "#3ecf8e" },
} as const;

export function Logomark({ size = 26 }: { size?: number }) {
  const { scheme } = useTheme();
  const c = schemes[scheme === "dark" ? "dark" : "light"];
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      accessibilityLabel="MintStint"
    >
      <Path d="M32 32 L32 16 A16 16 0 0 1 47.8 34.8 Z" fill={c.accent} />
      <Circle
        cx="32"
        cy="32"
        r="20"
        fill="none"
        stroke={c.ink}
        strokeWidth="5"
      />
    </Svg>
  );
}
